import { _CO, _INPUT_SALE_REGROUPING, _MONTHS } from "../../../utils/constants";
import { createColumn } from "../../../utils/AgGridUtils/ColumnBuilders/createColumn";
import { formatNumber } from "../../../utils/function";
import { monthsCalculvalueGetter } from "./monthsCalculvalueGetter";

export const columnBuilderMonths = (
  generatedColumns,
  tab,
  discountIncreases,
) => {
  for (let i = 1; i <= 12; i++) {
    const fiscalMonthIndex = _CO[i];

    generatedColumns.push(
      createColumn({
        headerName: _MONTHS[fiscalMonthIndex],
        headerTooltip: _MONTHS[fiscalMonthIndex],
        field: `months.${fiscalMonthIndex}`,
        editable: (params) => {
          return (
            params?.data?.type !==
              _INPUT_SALE_REGROUPING.EXTERNAL_CREDIT_GROUPING &&
            !params?.data?.type.includes("vide") &&
            params?.data?.type !== _INPUT_SALE_REGROUPING.DEPOT_GROUPING &&
            params?.data?.type !==
              _INPUT_SALE_REGROUPING.EXTERNAL_CREDIT_DISCOUNT_GROUPING
          );
        },
        headerClass: "month-header",
        cellDataType: "number",
        aggFunc: "sum",
        flex: 1,
        valueGetter: (params) => {
          return monthsCalculvalueGetter(params, tab, discountIncreases);
        },
        valueFormatter: (params) => {
          if (
            params?.data?.type.includes("vide") ||
            params?.data?.type ===
              _INPUT_SALE_REGROUPING.EXTERNAL_CREDIT_DISCOUNT_GROUPING
          ) {
            return "";
          }
          if (
            params.data !== undefined &&
            params.data.sale.includes("Discount")
          ) {
            return `${params.value ? params.value : 0} %`;
          }

          if (
            (params.data !== undefined && params?.data?.sale.includes("By")) ||
            tab === "value"
          ) {
            return `${params.value ? formatNumber(params.value) : 0}`;
          }

          return `${params.value ? formatNumber(params.value) : 0} T`;
        },
        valueParser: (params) => {
          // Remove spaces and parse to float if string
          if (typeof params?.newValue === "string") {
            return parseFloat(params?.newValue?.replace(/\s/g, "") || 0);
          } else {
            return params?.newValue;
          }
        },
      }),
    );
  }
};
